import { Intent } from '@teetsh/app/src/components/Buttons/BaseButtonProps';
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Icon } from '@teetsh/app/src/components/Icons/icon';

export default function getIconName(icon?: any, intent?: Intent): Icon {
  // 1. no icon
  if (icon === null) {
    return undefined;
  }
  // 2. defined iconName prop
  if (icon !== undefined) {
    return icon;
  }
  // 3. default intent icon
  switch (intent) {
    case 'danger':
      return ExclamationCircleIcon;
    case 'primary':
      return InformationCircleIcon;
    case 'warning':
      return ExclamationTriangleIcon;
    case 'success':
      return CheckCircleIcon;
    default:
      return undefined;
  }
}
